export default "__VITE_ASSET__3V5C3vlM__"